
import React from 'react';
import { ReadingDay2025 } from '../views';


const RentalPage = () => {
  return <ReadingDay2025/>;
};

export default RentalPage;
